import type { App, Plugin } from 'vue';
import VlDataTableExtendedInstaller from './vl-ui-data-table-extended';

export function registerWebcomponentsAsVue3(app: App) {
  for (const component in app._context.components) {
    if (component.startsWith('vl-')) {
      (app._context.components[component] as any).compatConfig = {
        MODE: 3
      };
    }
  }
}

export const LocalVue3WebComponentsPlugin: Plugin = {
  install(app: App): void {
    app.use(VlDataTableExtendedInstaller);
  }
};
